// VendorDropdown.jsx
import React, { useState, useEffect, useMemo } from "react";
import { Autocomplete, TextField, CircularProgress, Typography } from "@mui/material";
import {  axiosInstance } from "../utils/commonImports";

const VendorDropdown = ({ vendorId, clientId, onVendorChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  // ============================
  // Fetch Vendors
  // ============================
  useEffect(() => {
    if (!clientId) return;

    setLoading(true);
  axiosInstance
      .get(`/api/vendors?client_id=${clientId}`)
      .then((res) => {
        setOptions(res.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [clientId]);

  // ============================
  // Find selected vendor OBJECT
  // ============================
  const selectedVendor = useMemo(() => {
    if (!vendorId || options.length === 0) return null;

    return (
      options.find((v) => Number(v.vendorid) === Number(vendorId)) || null
    );
  }, [vendorId, options]);

  // ============================
  // Debug (keep for now)
  // ============================
  console.log("VendorDropdown:", {
    vendorId,
    selectedVendor,
    optionsCount: options.length,
  });

  return (
    <Autocomplete
      options={options}
      loading={loading}
      value={selectedVendor}
      disableClearable={false}

      isOptionEqualToValue={(option, value) =>
        Number(option.vendorid) === Number(value.vendorid)
      }

      getOptionLabel={(option) =>
        option?.vendorname ? option.vendorname : ""
      }

      onChange={(event, newValue) => {
        if (newValue) {
          onVendorChange({
            vendor_id: newValue.vendorid,
            vendor_name: newValue.vendorname,
            vendor_primary_contact_name:
              newValue.vendorprimarycontactname || "",
            vendor_primary_contact_phone:
              newValue.vendorprimarycontactphone || "",
            vendor_primary_contact_email:
              newValue.vendorprimarycontactemail || "",
            vendor_service_city: newValue.vendorservicecity || "",
          });
        } else {
          onVendorChange({
            vendor_id: "",
            vendor_name: "",
            vendor_primary_contact_name: "",
            vendor_primary_contact_phone: "",
            vendor_primary_contact_email: "",
            vendor_service_city: "",
          });
        }
      }}

      renderOption={(props, option) => (
        <li {...props} key={option.vendorid}>
          <Typography variant="body2">
            {option.vendorname}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {option.vendorprimarycontactname} | {option.vendorprimarycontactphone} |{" "}
            {option.vendorprimarycontactemail} | {option.vendorservicecity}
          </Typography>
        </li>
      )}

      renderInput={(params) => (
        <TextField
          {...params}
          label="Vendor Name"
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress size={18} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default VendorDropdown;
